import * as React from "react"

const SvgRightArrowMenu = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.219}
    height={18.839}
    viewBox="0 0 11.219 18.839"
    {...props}
  >
    <path
      d="m.7.714 9.074 8.9-9.074 8.5"
      fill="none"
      stroke="#e32223"
      strokeWidth={2}
    />
  </svg>
)

export default SvgRightArrowMenu
